const iconButtonPadding = {
    small: 4,
    medium: 6
};
const MuiIconButton = {
    defaultProps: {},
    styleOverrides: {
        root: ({ theme })=>({
                borderRadius: theme.shape.borderRadius
            }),
        sizeSmall: {
            padding: iconButtonPadding.small
        },
        sizeMedium: {
            padding: iconButtonPadding.medium
        }
    }
};
export { MuiIconButton, iconButtonPadding };

//# sourceMappingURL=icon-button-overrides.js.map